<div class="d-block position-absolute top-0 start-0 w-100 h-100 overflow-hidden">
  <div class="sidenav d-none d-md-block"></div>
  <div class="main bg-white">
    <div class="login-form-container">
      <img src="./assets/images/SmartDukaan_Logo_Transparent.png" style="width: 114px; " loading="lazy">
      <div class="login-form mt-3">

        <form (submit)="signIn()">
          <div class="form-group">

            <label for="mobile" class="fs-12 grey-color pb-1">Mobile Number <span class="brand-color">*</span></label>
            <input
              type="number"
              id="mobile"
              name="mobile"
              required
              md-maxlength="10"
              [(ngModel)]="user.mobile"
              class="form-control custom-form"
              [disabled]="customerId > 0"
              placeholder="Mobile Number">
          </div>
          <div class="form-group pt-3">
            <label for="password" class="fs-12 grey-color pb-1">Password <span class="brand-color">*</span></label>
            <input
              type="password"
              id="password"
              name="password"
              required
              [(ngModel)]="user.password"
              class="form-control custom-form"
              placeholder="Password">
            <p>
              <span style="font-size:13px;color:#f67575;">
                Your password must be at least 8 characters including a lowercase letter, an uppercase letter, and a number
              </span>
            </p>
          </div>
          <div class="d-grid mt-3">
            <button [disabled]="loading" class="btn btn-black text-white brand-bg border-light" type="submit">Login</button>
          </div>
<!--          <div class="d-grid mt-3">-->
<!--            <button type="button" class="btn btn-secondary" (click)="register()">Register</button>-->
<!--          </div>-->
          <div class="fs-12 grey-color mt-3 "   style="cursor: pointer;" role="button" (click)="register()">
            Don't have an account yet? <span class="brand-color">Sign Up here</span>
          </div>
          <div class="fs-12 grey-color mt-2  "  (click)="visible = true" style="cursor: pointer;">
            Forget your password? <span class="brand-color">Reset here</span>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<p-dialog header="Reset your password" [modal]="true" [(visible)]="visible" [style]="{ width: '40rem' }">
  <div class="container" style="max-width: 600px; max-height: 100%">
    <div class="bg-color px-4 pt-3 pb-5">
      <div *ngIf="otpRequested">
        <div class="fs-6 fw-normal pb-1">Reset your password</div>
        <form class="pt-2" (submit)="requestOtp()">
          <label for="mobile" class="fs-12 grey-color pb-1">Mobile Number <span class="brand-color">*</span></label>
          <input type="number" name="mobile" placeholder="Enter Your Mobile Number" required md-maxlength="10" [(ngModel)]="user.mobile" class="form-control custom-form">
          <button type="submit" [disabled]="loading" class="btn btn-danger mt-3" style="box-shadow:none;">Request OTP</button>
        </form>
      </div>
      <div *ngIf="otpSend">
        <div class="fs-6 fw-normal pb-1">Enter OTP to Reset Password</div>
        <form class="pt-2" (submit)="verifyOtp()">
          <label for="otp" class="fs-12 grey-color pb-1">Enter OTP <span class="brand-color">*</span></label>
          <input type="text" name="otp" required [(ngModel)]="otpValue" class="form-control custom-form">
          <button type="submit" [disabled]="loading" class="btn btn-danger mt-3">Submit OTP</button>
        </form>
      </div>

      <form *ngIf="verified" class="pt-2" (submit)="resetPassword()">
        <div class="">
          <label for="newpassword" class="fs-12 grey-color pb-1">
            Enter New Password <span class="brand-color">*</span>
          </label>
          <div class="password-container">
            <input
              [type]="showNewPassword ? 'text' : 'password'"
              id="newpassword"
              name="password"
              placeholder="Password"
              required
              [(ngModel)]="user.password"
              class="form-control fs-6 mt-6"
            />
            <span
              class="password-toggle"
              (click)="toggleNewPasswordVisibility()"
            >
        <i [class]="showNewPassword ? 'pi pi-eye' : 'pi pi-eye-slash'"></i>
      </span>
          </div>
          <small class="text-danger">
            Password must contain at least one number and one alphabet.
          </small>
        </div>

        <div class="pt-3">
          <label for="confirmPassword" class="fs-12 grey-color pb-1">
            Confirm Password <span class="brand-color">*</span>
          </label>
          <div class="password-container">
            <input
              [type]="showConfirmPassword ? 'text' : 'password'"
              id="confirmPassword"
              name="confirmPassword"
              placeholder="Confirm Password"
              required
              [(ngModel)]="user.confirmPassword"
              class="form-control fs-6"
            />
            <span
              class="password-toggle"
              (click)="toggleConfirmPasswordVisibility()"
            >
        <i [class]="showConfirmPassword ? 'pi pi-eye' : 'pi pi-eye-slash'"></i>
      </span>
          </div>
          <small class="text-danger">
            Password must contain at least one number and one alphabet.
          </small>
        </div>

        <div class="d-grid mt-5">
          <button
            color="primary"
            type="submit"
            [disabled]="loading"
            class="btn btn-danger"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
</p-dialog>
